import ActionHelper from "../helpers/ActionHelper";

export const deleteFile = (fileId) =>
  ActionHelper.requestServer("DELETE", `/file/${fileId}`);

export const updateFile = (fileId, payload) =>
  ActionHelper.requestServer("PUT", `/file/${fileId}`, payload);



// WEBPACK FOOTER //
// ./src/actions/fileActions.js